export default __webpack_public_path__ + "static/media/Create.ed6f2dc9.png";